// EP-59 — the field copy is generic "Code" so the same auth flow works
// for both RentalLease (tenants) and OwnerContract (condo co-owners).
// LIFF can't know the account_type before the user authenticates.
// 2026-10-01 (owner): the title names the lease code and says what the
// code is for; the field label and placeholder stay generic.
export default {
  lease_code_title: 'Enter your lease code to receive OTP',
  lease_code_label: 'Code',
  lease_code_placeholder: 'e.g. AB123456',
  send_otp: 'Submit',
  otp_title: 'Enter OTP',
  otp_subtitle: 'We sent a 6-digit code to',
  otp_label: 'One-Time Password',
  otp_expires: 'Code expires in {{seconds}}s',
  otp_expired: 'Code expired',
  resend_otp: 'Resend OTP',
  verify_otp: 'Verify',
  lease_not_found: 'Code not found. Please check and try again.',
  otp_invalid: 'Invalid or expired OTP. Please try again.',
  rate_limited: 'Too many requests. Please wait before trying again.',
  no_phone: 'No phone number registered. Please contact your landlord or juristic person.',
  account_unavailable:
    'This property is not available in the app right now. Please contact your landlord or juristic person.',
  scan_qr_code: 'Scan QR Code',
  scan_invalid_format: 'Invalid QR code. Please scan a valid code.',
  scan_permission_denied: 'Camera access denied. Please allow camera permission.',
  // EP-160 T160-103l: the privacy notice (PDPA s.23). A notice, not a consent.
  privacy_notice_title: 'Privacy notice',
  privacy_notice_controller: '{{name}} is the controller of your personal data',
  privacy_notice_contact: 'Contact: {{contact}}',
  privacy_notice_processor: '{{processor}} processes the data on its behalf',
  privacy_notice_policy_link: 'FlowRent privacy policy',
  privacy_notice_acknowledge: 'Got it',
  privacy_notice_error: 'Could not save. Please try again.',
}
